import React from 'react';
import Layout from '../layouts/claire';
import { Link } from 'react-router';
import { Animated } from 'react-animated-css';
import config from '../../config';
import Menu from '../partials/menu';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import TopRightMenu from '../partials/top_right_menu';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import LineLoader from '../partials/line_loader';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../partials/custom_date_picker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { sortFloors } from '../../helpers';
import ReportTabs from './report_tabs';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale, LinearScale, BarElement,
    Title, Tooltip, Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const KpiCard = ({ label, value, icon, color = '#00C6FE', sub }) => (
    <div className="bg-gray-2 p-3 d-flex flex-column" style={{ borderRadius: 8, minWidth: 140, borderLeft: `3px solid ${color}` }}>
        <div className="d-flex align-items-center justify-content-between mb-1">
            <span className="gray font-10 poppins">{label}</span>
            {icon && <i className={`${icon} font-12`} style={{ color }} />}
        </div>
        <span className="white poppins toBold" style={{ fontSize: '1.7rem', lineHeight: 1 }}>{value}</span>
        {sub && <span className="font-10 mt-1 poppins" style={{ color }}>{sub}</span>}
    </div>
);

class Forecast extends React.Component {
    state = {
        menu_toggled: false,
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        filters: localStorage.getItem('lb.reports.filters') ? (() => {
            const f = JSON.parse(localStorage.getItem('lb.reports.filters'));
            return {
                CheckIn: f.CheckIn ? moment(f.CheckIn).utc() : moment().utc(),
                CheckOut: f.CheckOut ? moment(f.CheckOut).utc() : moment().add(10, 'days').utc(),
                IdRoom: null,
            };
        })() : {
            CheckIn: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').utc(),
            CheckOut: moment(moment().format('YYYY-MM-DD'), 'YYYY-MM-DD').add(10, 'days').utc(),
            IdRoom: null,
        },
        pickRoom: false,
        showChart: true,
    }

    componentWillMount() {
        const { params } = this.props;
        let user = fakeAuth.getUser();
        if (user.Permissions & (config.permissions.SuperAdmin | config.permissions.Reports) === 0) {
            this.props.router.goBack();
        } else {
            this.props.properties_actions && this.props.properties_actions.fetch_one(params.id);
            this.props.floors_actions && this.props.floors_actions.fetch(params.id);
            this.props.rooms_actions && this.props.rooms_actions.fetch(params.id);
        }
    }

    componentWillReceiveProps = nextProps => {
        const { floors = [], bookings, rooms } = nextProps;
        if (!rooms) return;

        let resources = [];
        sortFloors(floors).forEach(floor => {
            _.sortBy(floor.Pieces, 'Label').forEach(piece => {
                resources.push({
                    status: piece.Status,
                    id: piece.IdPiece,
                    floor: floor.Label,
                    title: piece.Label,
                    name: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).GivenName,
                    IdRoom: (_.find(rooms, r => r.IdRoom === piece.IdRoom) || {}).IdRoom,
                });
            });
        });

        rooms.forEach(r => { r.TOTAL = _.filter(resources, x => x.IdRoom === r.IdRoom).length; });

        this.setState({
            floors,
            bookings,
            all_booked_rooms: _.chain(bookings).map(b => b.Rooms).flatten().compact().value(),
            resources,
            rooms: [{ GivenName: 'Todas', TOTAL: resources.length, IdRoom: null }, ...rooms],
            bootstrapped: !!bookings,
        });
    }

    onFetch = () => {
        const { filters } = this.state;
        localStorage.setItem('lb.reports.filters', JSON.stringify({
            CheckIn: filters.CheckIn,
            CheckOut: filters.CheckOut,
        }));
        this.props.booking_actions && this.props.booking_actions.fetch_range({
            IdProperty: this.props.params.id,
            CheckIn: moment(filters.CheckIn).format('YYYY-MM-DD'),
            CheckOut: moment(filters.CheckOut).format('YYYY-MM-DD'),
        });
    }

    getDates = () => {
        const { filters } = this.state;
        const dates = [];
        let cur = moment(filters.CheckIn);
        const end = moment(filters.CheckOut);
        while (cur.isSameOrBefore(end)) {
            dates.push(cur.clone());
            cur.add(1, 'days');
        }
        return dates;
    }

    getDayStats = (date) => {
        const { all_booked_rooms, filters, rooms } = this.state;
        const filter = r => filters.IdRoom ? r.IdRoom === filters.IdRoom : true;
        const selected_room = _.find(rooms, r => r.IdRoom === filters.IdRoom) || rooms?.[0] || { TOTAL: 1 };

        const today = _.chain(all_booked_rooms).filter(r => date.isBetween(moment(r.CheckIn), moment(r.CheckOut))).filter(filter).value();
        const tomorrow = _.chain(all_booked_rooms).filter(r => date.clone().add(1, 'day').isBetween(moment(r.CheckIn), moment(r.CheckOut))).filter(filter).value();
        const entradas = _.chain(all_booked_rooms).filter(r => date.isSame(moment(r.CheckIn), 'day')).filter(filter).value();
        const salidas = _.chain(all_booked_rooms).filter(r => date.isSame(moment(r.CheckOut), 'day')).filter(filter).value();

        const sum = (arr, key) => _.chain(arr).map(r => r[key]).reduce((a, b) => a + b, 0).value();
        const total = selected_room.TOTAL || 1;
        const occ_pct = Math.round(tomorrow.length * 100 / total);

        return { today, tomorrow, entradas, salidas, occ_pct, total, available: total - tomorrow.length, sum };
    }

    renderKpis = () => {
        const { all_booked_rooms, filters, resources } = this.state;
        if (!all_booked_rooms) return null;

        const dates = this.getDates();
        const occs = dates.map(d => this.getDayStats(d).occ_pct);
        const avgOcc = occs.length ? Math.round(_.sum(occs) / occs.length) : 0;
        const maxOcc = occs.length ? Math.max(...occs) : 0;
        const totalEntradas = _.sum(dates.map(d => this.getDayStats(d).entradas.length));
        const totalSalidas = _.sum(dates.map(d => this.getDayStats(d).salidas.length));
        const fuCount = _.chain(resources || [])
            .filter(r => filters.IdRoom ? r.IdRoom === filters.IdRoom : true)
            .filter(r => (r.status & 2048) || (r.status & 64) || (r.status & 32))
            .value().length;

        return (
            <div className="d-flex flex-wrap mt-3 mb-2" style={{ gap: 10 }}>
                <KpiCard label="% Ocup. promedio" value={`${avgOcc}%`} icon="fas fa-percent" color="#00C6FE" sub={`${dates.length} días`} />
                <KpiCard label="Pico de ocupación" value={`${maxOcc}%`} icon="fas fa-arrow-up" color="#6E44FF" />
                <KpiCard label="Total entradas" value={totalEntradas} icon="fas fa-sign-in-alt" color="#00c97a" />
                <KpiCard label="Total salidas" value={totalSalidas} icon="fas fa-sign-out-alt" color="#FFC107" />
                {fuCount > 0 && <KpiCard label="F/U (Mantenimiento)" value={fuCount} icon="fas fa-tools" color="#FF6B6B" />}
            </div>
        );
    }

    renderChart = () => {
        const { all_booked_rooms } = this.state;
        if (!all_booked_rooms || !all_booked_rooms.length) return null;

        const dates = this.getDates();
        const labels = dates.map(d => d.format('DD/MM'));
        const occs = dates.map(d => this.getDayStats(d).occ_pct);

        const data = {
            labels,
            datasets: [
                {
                    label: '% Ocupación',
                    data: occs,
                    backgroundColor: occs.map(v => v >= 80 ? '#00c97a99' : v >= 50 ? '#00C6FE99' : '#6E44FF99'),
                    borderColor: occs.map(v => v >= 80 ? '#00c97a' : v >= 50 ? '#00C6FE' : '#6E44FF'),
                    borderWidth: 1,
                    borderRadius: 4,
                },
            ],
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    callbacks: {
                        label: ctx => ` ${ctx.raw}% ocupación`,
                    },
                },
            },
            scales: {
                y: {
                    min: 0,
                    max: 100,
                    ticks: { color: '#888', callback: v => `${v}%` },
                    grid: { color: '#333' },
                },
                x: {
                    ticks: { color: '#888', font: { size: 10 } },
                    grid: { color: '#333' },
                },
            },
        };

        return (
            <div className="bg-gray-2 p-3 mt-3" style={{ borderRadius: 8 }}>
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <span className="white poppins font-12 toBold">Ocupación diaria</span>
                    <button className="btn btn-link font-10 gray" onClick={() => this.setState({ showChart: !this.state.showChart })}>
                        <i className={`fas fa-chevron-${this.state.showChart ? 'up' : 'down'}`} />
                    </button>
                </div>
                {this.state.showChart && (
                    <div style={{ height: 180 }}>
                        <Bar data={data} options={options} />
                    </div>
                )}
            </div>
        );
    }

    renderFilters = () => {
        const { filters, rooms = [] } = this.state;
        const selectedRoom = _.find(rooms, r => r.IdRoom === filters.IdRoom) || rooms[0] || {};

        return (
            <Animated animationIn="fadeInDown" animationInDuration={200} className="d-flex flex-wrap align-items-flex-end mt-3" style={{ gap: 10 }}>

                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Desde</label>
                    <DatePicker
                        selected={filters.CheckIn}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Inicio" />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        maxDate={filters.CheckOut}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckIn = moment(date).utc();
                            this.setState({ filters });
                        }}
                    />
                </div>

                <div style={{ minWidth: 140 }}>
                    <label className="white poppins font-11 d-block mb-1">Hasta</label>
                    <DatePicker
                        selected={filters.CheckOut}
                        customInput={<CustomDatePicker format="DD/MM/YYYY" hint="Fin" clear={() => {
                            const { filters } = this.state;
                            filters.CheckOut = null;
                            this.setState({ filters });
                        }} />}
                        showYearDropdown scrollableYearDropdown yearDropdownItemNumber={15}
                        minDate={filters.CheckIn}
                        onChange={date => {
                            const { filters } = this.state;
                            filters.CheckOut = moment(date).utc();
                            this.setState({ filters });
                        }}
                    />
                </div>

                {rooms.length > 0 && (
                    <div style={{ minWidth: 180 }}>
                        <label className="white poppins font-11 d-block mb-1">Tipo de habitación</label>
                        <div className="black-input d-flex">
                            <Dropdown isOpen={this.state.pickRoom} toggle={() => this.setState({ pickRoom: !this.state.pickRoom })} className="w-100">
                                <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="w-100 p-3 white bg-transparent d-flex">
                                    <span className="align-self-center font-12">{selectedRoom.GivenName} ({selectedRoom.TOTAL})</span>
                                    <i className="fas fa-chevron-down font-12 white align-self-center ms-auto" />
                                </DropdownToggle>
                                <DropdownMenu className="w-100" style={{ maxHeight: 260, overflowY: 'auto' }}>
                                    {rooms.map((c, i) => (
                                        <DropdownItem key={i} onClick={() => {
                                            const { filters } = this.state;
                                            filters.IdRoom = c.IdRoom;
                                            this.setState({ filters, pickRoom: false });
                                        }}>{c.GivenName} ({c.TOTAL})</DropdownItem>
                                    ))}
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                )}

                <div className="d-flex align-items-flex-end" style={{ gap: 6, alignSelf: 'flex-end' }}>
                    <button onClick={this.onFetch} className="btn btn-blue white d-flex align-items-center px-3" style={{ height: 46 }}>
                        <i className="fas fa-search font-14 me-2" />
                        <span className="poppins font-12">Buscar</span>
                    </button>
                    {this.state.bootstrapped && this.state.all_booked_rooms?.length > 0 && (
                        <ReactHTMLTableToExcel
                            id="forecast-xls"
                            className="btn btn-link white bordered d-flex align-items-center px-3"
                            style={{ height: 46 }}
                            table="forecast-table-xls"
                            filename="Forecast"
                            sheet="Forecast"
                            buttonText={<><i className="fas fa-file-excel font-14 me-2" /><span className="poppins font-12">Exportar</span></>}
                        />
                    )}
                </div>
            </Animated>
        );
    }

    renderDay = (date, index) => {
        const stats = this.getDayStats(date);
        const { sum, today, tomorrow, entradas, salidas, occ_pct, total, available } = stats;
        const show = v => v || <span className="gray">0</span>;

        return (
            <tr key={index} className="font-9 text-center">
                <td className="text-left" style={{ whiteSpace: 'nowrap' }}>
                    <span className="white">{date.format('DD/MM/YYYY')}</span>
                    <br />
                    <span className="gray font-8">{date.locale('es').format('ddd').toUpperCase()}</span>
                </td>

                <td className="w3-blue">{show(today.length)}</td>
                <td className="w3-blue">{show(sum(today, 'Adults'))}</td>
                <td className="w3-blue">{show(sum(today, 'Children'))}</td>
                <td className="w3-blue">{show(sum(today, 'Cribs'))}</td>

                <td className={entradas.length ? 'w3-green' : ''}>{show(entradas.length)}</td>
                <td className={sum(entradas, 'Adults') ? 'w3-green' : ''}>{show(sum(entradas, 'Adults'))}</td>
                <td className={sum(entradas, 'Children') ? 'w3-green' : ''}>{show(sum(entradas, 'Children'))}</td>
                <td className={sum(entradas, 'Cribs') ? 'w3-green' : ''}>{show(sum(entradas, 'Cribs'))}</td>

                <td className={salidas.length ? 'w3-yellow black' : ''}>{show(salidas.length)}</td>
                <td className={sum(salidas, 'Adults') ? 'w3-yellow black' : ''}>{show(sum(salidas, 'Adults'))}</td>
                <td className={sum(salidas, 'Children') ? 'w3-yellow black' : ''}>{show(sum(salidas, 'Children'))}</td>
                <td className={sum(salidas, 'Cribs') ? 'w3-yellow black' : ''}>{show(sum(salidas, 'Cribs'))}</td>

                <td className={tomorrow.length ? 'w3-purple white' : ''}>{show(tomorrow.length)}</td>
                <td className={sum(tomorrow, 'Adults') ? 'w3-purple white' : ''}>{show(sum(tomorrow, 'Adults'))}</td>
                <td className={sum(tomorrow, 'Children') ? 'w3-purple white' : ''}>{show(sum(tomorrow, 'Children'))}</td>
                <td className={sum(tomorrow, 'Cribs') ? 'w3-purple white' : ''}>{show(sum(tomorrow, 'Cribs'))}</td>

                <td>
                    <span style={{
                        display: 'inline-block', borderRadius: 4, padding: '1px 6px',
                        background: occ_pct >= 80 ? '#00c97a33' : occ_pct >= 50 ? '#00C6FE33' : '#ffffff22',
                        color: occ_pct >= 80 ? '#00c97a' : occ_pct >= 50 ? '#00C6FE' : '#aaa',
                        fontWeight: 600,
                    }}>{occ_pct}%</span>
                </td>
                <td className="white">{available}</td>
                <td className="gray">{100 - occ_pct}%</td>
            </tr>
        );
    }

    renderTable = () => {
        const dates = this.getDates();

        return (
            <table className="table font-10" id="forecast-table-xls" style={{ minWidth: 900 }}>
                <thead>
                    <tr>
                        <th rowSpan={2} className="align-middle">Fecha</th>
                        <th colSpan={4} className="text-center w3-blue white">Inicial</th>
                        <th colSpan={4} className="text-center w3-green white">Entradas</th>
                        <th colSpan={4} className="text-center w3-yellow black">Salidas</th>
                        <th colSpan={4} className="text-center w3-purple white">Final</th>
                        <th colSpan={3} className="text-center">Estadísticas</th>
                    </tr>
                    <tr className="font-8 gray">
                        <td>Hab</td><td>Adl</td><td>Niñ</td><td>Cuna</td>
                        <td>Hab</td><td>Adl</td><td>Niñ</td><td>Cuna</td>
                        <td>Hab</td><td>Adl</td><td>Niñ</td><td>Cuna</td>
                        <td>Hab</td><td>Adl</td><td>Niñ</td><td>Cuna</td>
                        <td>%Ocu</td><td>Disp</td><td>%Disp</td>
                    </tr>
                </thead>
                <tbody>
                    {dates.map((date, i) => this.renderDay(date, i))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={20} className="text-right gray font-10 poppins">
                            F/U (Mantenimiento): {_.chain(this.state.resources || [])
                                .filter(r => this.state.filters.IdRoom ? r.IdRoom === this.state.filters.IdRoom : true)
                                .filter(r => (r.status & 2048) || (r.status & 64) || (r.status & 32))
                                .value().length}
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }

    renderCommon = () => {
        const { params } = this.props;
        return (
            <div>
                {this.renderHeader()}
                <ReportTabs active="forecast" id={params.id} />

                <div style={{ position: 'absolute', top: '11em', bottom: 0, left: 100, right: 0, display: 'flex', flexDirection: 'column' }} className="bg-gray-dark">

                    {/* Top zone: filters — no overflow so dropdowns show */}
                    <div className="px-3 pt-3" style={{ flexShrink: 0, position: 'relative', zIndex: 200 }}>
                        {this.renderFilters()}
                    </div>

                    {/* Bottom zone: scrollable */}
                    <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }} className="px-3 pb-3">
                        {this.state.bootstrapped && this.renderKpis()}
                        {this.state.bootstrapped && this.state.all_booked_rooms?.length > 0 && this.renderChart()}

                        {this.state.bootstrapped && this.state.all_booked_rooms?.length > 0 && (
                            <Animated animationIn="fadeInUp" animationInDuration={200}>
                                <div className="bg-gray-2 p-3 mt-3" style={{ borderRadius: 6, width: '100%' }}>
                                    {this.renderTable()}
                                </div>
                            </Animated>
                        )}

                        {this.state.bootstrapped && this.state.all_booked_rooms?.length === 0 && (
                            <div className="d-flex justify-content-center mt-5">
                                <span className="gray poppins font-14">No hay reservas en el período seleccionado.</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    renderHeader = () => (
        <div className="d-flex">
            <div className="w-100 d-flex">
                <i className="icon-lb_reportes blue font-40 align-self-center" />
                <div className="align-self-center d-flex flex-column">
                    <span className="white ms-3 font-20 line1 poppins">Reportes</span>
                    <Link to="/properties" className="white ms-3 font-10 poppins underlined">{this.state.hotel_name}</Link>
                </div>
            </div>
            <div className="w-100 d-flex align-self-center">
                <TopRightMenu {...this.props} />
            </div>
        </div>
    )

    render() {
        return (
            <Layout router={this.props.router} nbs="home" title="legendbeds" form={this.props.form} form_actions={this.props.form_actions}>
                <section>
                    {this.state.microTransac && <LineLoader />}

                    <div className="w3-container w3-hide-small" style={{ marginLeft: 100 }}>
                        <div style={{ height: 50 }} />
                        {this.renderCommon()}
                    </div>

                    <Menu {...this.state} {...this.props} />
                </section>
            </Layout>
        );
    }
}

export default Forecast;
